<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            source: String,
            company: {
                type: Object,
                default() {
                    return {}
                }
            },
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        components: {Spinner},
        data() {
            return {
                form: new Form({
                    first_name: this.data.first_name,
                    last_name: this.data.last_name,
                    email: this.data.email,
                    phone: this.company.phone_number,
                    message: ''
                }),
                status: false
            }
        },
        methods: {
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(response => this.$set(this, 'status', true))
            },
            onClose() {
                this.$set(this, 'status', false)
                this.$set(this.form, 'first_name', this.data.first_name)
                if (this.data.last_name) {
                    this.$set(this.form, 'last_name', this.data.last_name)
                }
                if (this.data.phone) {
                    this.$set(this.form, 'phone', this.data.phone)
                }
                this.$set(this.form, 'email', this.data.email)

                this.form.errors.clear()
                this.$set(this, 'status', false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyHelpForm.vue